import React from "react";
import { NewTab } from "../../../../components";
import AreaListAdv from "./ChartsNewListAdv/AreaListAdv";
import BarListAdv from "./ChartsNewListAdv/BarListAdv";
import ColumnListAdv from "./ChartsNewListAdv/ColumnListAdv";
import PieDonutListAdv from "./ChartsNewListAdv/PieDonutListAdv";
import TableListAdv from "./ChartsNewListAdv/TableListAdv";

const ChartsNewListAdv = () => {
  const tabList = [
    {
      title: "Table",
      page: <TableListAdv />,
      type: "main",
    },
    {
      title: "Area/Line Chart",
      page: <AreaListAdv />,
      type: "main",
    },
    {
      title: "Bar Chart",
      page: <BarListAdv />,
      type: "main",
    },
    {
      title: "Column Chart",
      page: <ColumnListAdv />,
      type: "main",
    },
    {
      title: "Pie/Donut Chart",
      page: <PieDonutListAdv />,
      type: "main",
    },
  ];
  return (
    <div className="flex-1 flex overflow-hidden">
      <NewTab
        tabs={tabList}
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="charts-new-list-adv"
      />
    </div>
  );
};

export default ChartsNewListAdv;
